
export enum Role{
    SuperAdmin='Super Admin',
    Admin='Admin',
    SecuritySupervisior='Security Supervisor',
    User = 'User',
}